/**
 * Reload on CSRF / session expiry (HTTP 419) so Inertia submits don't fail silently.
 * Cancels Inertia's default non-Inertia error modal for that status only.
 */

export function handleInertiaHttpException(event, win = window) {
  const status = event?.detail?.response?.status;

  if (status !== 419) {
    return false;
  }

  event.preventDefault();
  win.location.reload();

  return true;
}

export function startInertiaHttpExceptionHandler(router, win = window) {
  return router.on('httpException', (event) => {
    handleInertiaHttpException(event, win);
  });
}
